import { ButtonSecondary, RegPlate, typographyRem } from '@by-miles/bymiles-styles'
import React from 'react'

import { formatReg } from '../../utils/formatReg'
import { sanitizeCarModel } from '../../utils/sanitizeCarModel'
import { CoverDetailsStyles } from './CoverDetailsStyles'
const { paragraphBody: ParagraphBody, labelMedium: LabelMedium } = typographyRem

type CoverDetailsVehicle = {
  make: string | undefined
  reg: string | undefined
  model: string | undefined
  trim: string | undefined | null
}

interface CoverDetailsProps {
  vehicle: CoverDetailsVehicle
  onClick: () => void
  mainDriver: {
    firstNames: string | undefined | null
    lastNames: string | undefined | null
  }
  additionalDrivers: any[]
  tabFocusTrap: number
}

export const CoverDetails = ({ additionalDrivers, mainDriver, vehicle, onClick, tabFocusTrap }: CoverDetailsProps) => (
  <CoverDetailsStyles>
    <div className="content-wrapper">
      <div className="section">
        <LabelMedium className="heading LoNotSensitive">CAR</LabelMedium>
        <ParagraphBody>{vehicle.make}</ParagraphBody>
        <ParagraphBody>{sanitizeCarModel(vehicle)}</ParagraphBody>
      </div>
      <div className="section">
        <LabelMedium className="heading LoNotSensitive">REG PLATE</LabelMedium>
        <RegPlate>{formatReg(vehicle.reg)}</RegPlate>
      </div>
      <div className="section">
        <LabelMedium className="heading LoNotSensitive">MAIN DRIVER</LabelMedium>
        <ParagraphBody>
          {mainDriver.firstNames} {mainDriver.lastNames}
        </ParagraphBody>
      </div>
      <div className="section other-drivers">
        <LabelMedium className="heading LoNotSensitive">OTHER DRIVERS</LabelMedium>
        {additionalDrivers?.length > 0 ? (
          additionalDrivers.map(d => (
            <ParagraphBody className="driver LoNotSensitive">
              <span className="first-name">{d.first_names} </span>
              <span className="last-name">{d.last_names}</span>
            </ParagraphBody>
          ))
        ) : (
          <ParagraphBody className="LoNotSensitive">N/A</ParagraphBody>
        )}
      </div>
    </div>

    <ButtonSecondary
      onClick={onClick}
      className="edit-details LoNotSensitive"
      label="Edit my details"
      size="extraSmall"
      tabFocusTrap={tabFocusTrap}
    />
  </CoverDetailsStyles>
)
